import React from 'react'

function Youtube() {
    return (
        <div>
               <div className="youtubeview">
       
       <iframe className="iframe"  src="https://www.youtube.com/embed/NpzFg8oOfaU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
       </div>
       <div className="youtubeview">
       <iframe className="iframe"  src="https://www.youtube.com/embed/22QK7lCO5ws" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
         </div>
        </div>
    )
}

export default Youtube

